import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import {
  useField,
  useFormContext,
} from 'modules/operation/common/forms/operationForm';

import { Section } from '../../Section';

export const FinancialInstrumentSection = () => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();
  const { field } = useField('order');

  return (
    <Section
      datax="operation-form-basic-information-section"
      title={t('operation.sections.financialInstrumentSection.title')}
    >
      <GridFields>
        <Input
          readOnly
          showCopyButton
          disabled={!readOnly}
          label={t(
            'operation.sections.financialInstrumentSection.fields.isin.label'
          )}
          value={field.value?.record?.isin ?? ''}
        />
        <Input
          readOnly
          showCopyButton
          disabled={!readOnly}
          label={t(
            'operation.sections.financialInstrumentSection.fields.issueCode.label'
          )}
          value={field.value?.record?.issueCode ?? ''}
        />
        <Input
          readOnly
          showCopyButton
          disabled={!readOnly}
          label={t(
            'operation.sections.financialInstrumentSection.fields.securityType.label'
          )}
          value={field.value?.record?.securityType ?? ''}
        />
      </GridFields>
    </Section>
  );
};
